<template>
  <div class="error-notification" @click.self="$emit('closeErrorModal')">
    <div class="error-notification__container">
      <v-icon
          class="error-notification__btn-close"
          color="primary"
          @click.self="$emit('closeErrorModal')"
      >
        mdi-close
      </v-icon>
      <div class="error-notification__title">{{ title }}</div>
      <div class="error-notification__list">
        <div class="list__item" v-for="(message, index) in messages" :key="index">{{ message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowErrorMessages",
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped>

.error-notification {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.error-notification__container {
  width: 60vw;
  min-height: 50vh;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 40px;
  background-color: white;
  border-radius: 10px;
  z-index: 101;
}

.error-notification__title {
  font-weight: bold;
  margin-bottom: 20px;
}

.error-notification__btn-close {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 102;
}

.list__item {
  margin-bottom: 10px;

}

</style>